export enum CfmResponseFieldBillingType {
  Invoice = "invoice",
  Credit = "credit",
}
